import Section1 from "./Section1";

export default Section1;
